export const filterById =
  <ID extends { serialize: () => string }, E extends { id: ID }>(id: ID | ID[], shouldBeEqual = false) =>
  (e: E) => {
    const ids = Array.isArray(id) ? id : [id];
    const contains = ids.some((entity) => e.id.serialize() === entity.serialize());
    return shouldBeEqual ? contains : !contains;
  };
